export default __webpack_public_path__ + "media/images/users2-a87e9a4e4b516b23455984c890ebfd70.png";